module.exports = __webpack_public_path__ + "a6ea2966.png";